import { atom } from 'jotai'

export type RiskSideDrawerLayerTabs = 'layers' | 'risk' | 'selection' | 'risk_table'

// Default value same as Redux initialState
export const infoLayerFocusAtom = atom<RiskSideDrawerLayerTabs>('layers')
